/**
 * @file contains a hook for getting attachment actions (download and preview)
 */

import { useRef } from 'react';

import { Message } from '../../generated/graphql';
import { AttachmentType } from '../../models/attachment';

import useAttachmentAction from './useAttachmentAction';

/**
 * Hook for getting attachment actions (download and preview)
 *
 * @param attachment Attachment object
 * @param messageId  Id of the current message
 * @returns          Object with download and preview actions
 */
const useGetAttachmentActions = (
  attachment: AttachmentType,
  messageId?: Message['id'],
) => {
  const downloadLinkRef = useRef<HTMLAnchorElement>(null);
  const previewLinkRef = useRef<HTMLAnchorElement>(null);
  const actionDownload = useAttachmentAction(
    attachment,
    'download',
    downloadLinkRef,
    messageId,
  );
  const actionPreview = useAttachmentAction(
    attachment,
    'preview',
    previewLinkRef,
    messageId,
  );

  return { actionDownload, actionPreview };
};

export default useGetAttachmentActions;
